module.exports = __webpack_public_path__ + "static/media/bmwlogo.b507ce67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bmwlogo.jpg
// module id = 1026
// module chunks = 0